/**
 * Thema subject rules (issue #75750).
 *
 * ONIX subject scheme 93 is the Thema subject category; schemes 94–99 are
 * Thema qualifiers (place, language, time, educational purpose, interest age,
 * style). A qualifier may only be present on a title together with at least
 * one Thema subject category term.
 */
export var THEMA_SUBJECT_CATEGORY_SCHEME = "93";
export var THEMA_QUALIFIER_SCHEMES = [
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
];
var schemeOf = function (subject) { var _a; return (_a = subject === null || subject === void 0 ? void 0 : subject.scheme) === null || _a === void 0 ? void 0 : _a.value; };
export var isThemaQualifierScheme = function (scheme) {
    return !!scheme && THEMA_QUALIFIER_SCHEMES.includes(scheme);
};
export var hasThemaSubjectCategory = function (subjects) {
    return (subjects !== null && subjects !== void 0 ? subjects : []).some(function (subject) { return schemeOf(subject) === THEMA_SUBJECT_CATEGORY_SCHEME; });
};
/** True when the subjects contain a Thema qualifier but no Thema category. */
export var violatesThemaQualifierRule = function (subjects) {
    return (subjects !== null && subjects !== void 0 ? subjects : []).some(function (subject) {
        return isThemaQualifierScheme(schemeOf(subject));
    }) && !hasThemaSubjectCategory(subjects);
};
